var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DragDialog',{attrs:{"title":"构件查询","width":600,"visible":_vm.visible,"footerBtn":[],"cancel":_vm.closeDialog},on:{"update:visible":function($event){_vm.visible=$event}}},[(_vm.isQueryFormVisible)?_c('QueryForm',{attrs:{"dataSetList":_vm.dataSetList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }